import React from 'react';
import File from 'src/components/File';
import { attachmentKey } from 'src/components/AnnotateImage/helpers';
import AttachmentPreview from './AttachmentPreview';
import './DetailsAttachments.scss';

export interface DetailsAttachmentsProps {
  onSelectFiles: (files: any) => void;
  isAttachmentRequired: boolean;
  attachments: any[];
  onDeleteAttachment: (item: any, index: number) => void;
  maxAttachments: number;
  canAddMoreAttachments: boolean;
  annotations: Record<string, string>;
}

const DetailsAttachments = ({
  onSelectFiles,
  isAttachmentRequired,
  attachments,
  onDeleteAttachment,
  maxAttachments,
  canAddMoreAttachments,
  annotations,
}: DetailsAttachmentsProps) => {
  return (
    <div className="details-attachments">
      <File
        label="Attachment"
        description={`${attachments.length}/${maxAttachments} files`}
        disabled={!canAddMoreAttachments}
        onSelect={onSelectFiles}
        files={[]}
        type="image"
        multiSelect
        required={isAttachmentRequired}
      />

      {attachments.map((attachment: any, index: number) => {
        const annotated: boolean = Boolean(
          annotations[attachmentKey(attachment)]
        );

        return (
          <AttachmentPreview
            key={index}
            attachment={attachment}
            annotated={annotated}
            onDelete={() => onDeleteAttachment(attachment, index)}
          />
        );
      })}
    </div>
  );
};

export default DetailsAttachments;
